import React, { useState, useEffect } from "react";
import { Modal, Card, Button } from "react-bootstrap";
import { styleModalComponent } from "./style";
import Separator from "../separator/separator";
import { BsTelephoneFill } from "react-icons/bs";
import { colors } from "../../styles/style";
import TimelineHistory from "../timeline/timelineHistory";
import ReactPanZoom from "react-image-pan-zoom-rotate";
import { Storage } from "aws-amplify";

/**
 * @param {String} orderInfo Información de la orden
 *
 * @param {Boolean} show Control para mostar la modal
 * @param {Function} handleClose Función para cerrar la modal
 * @returns Modal para presentar los detalles de la orden
 */
const ModalOrderDetails = ({ orderInfo, show, handleClose }) => {
  const [currentProducts, setCurrentProducts] = useState([]);
  const [sizeModal, setSizeModal] = useState("lg");
  const [classNameModal, setClassNameModal] = useState("");
  const [imageTicket, setImageTicket] = useState("");

  useEffect(() => {
    sortProducts();
    getImageTicket();
  }, []);

  const sortProducts = () => {
    if (orderInfo.shop_comments === "SOLUTIONS") {
      let newProd = orderInfo.products.items[0];
      let points = JSON.parse(orderInfo.products.items[0].comments);
      newProd.comments =
        "Recoger en la primer dirección " +
        points.pointA +
        " para entregar  " +
        points.pointB;
      setCurrentProducts([newProd]);
    } else if (orderInfo.shop_comments === "WISHES") {
      //console.log("line 34: ", JSON.parse(orderInfo?.history));
      let oldFormat = JSON.parse(orderInfo.products.items[0].comments);
      let newProds = [];
      oldFormat.forEach((element) => {
        let currProd = {
          id: element.id,
          product_id: {
            id: element.id,
            product_name: element.name,
            netcontent: "NA",
          },
          quantity: element.quantity,
        }; //initialProduct;
        /*  currProd.product_id.product_name = element.name;
                currProd.quantity = element.quantity;
                currProd.id = element.id; */
        newProds.push(currProd);
      });
      setCurrentProducts(newProds);
      //let newProds = products
    } else {
      setCurrentProducts(orderInfo.products.items);
    }
  };

  const getImageTicket = () => {
    if (
      orderInfo?.shop_comments === "WISHES" &&
      orderInfo?.products?.items[0]?.url_image
    ) {
      let urlTicket = orderInfo?.products?.items[0]?.url_image;
      Storage.get(urlTicket)
        .then((imageURL) => {
          setImageTicket(imageURL);
        })
        .catch((error) => {
          console.log("Error [getImage - CardItem] ", error);
        });
    }
  };

  const SectionProducts = () => {
    return (
      <div>
        <div style={styleModalComponent.titlesModalContainer}>
          <div className="row">
            <div className="col" style={styleModalComponent.colsContainer}>
              <Card.Text>Cantidad</Card.Text>
            </div>
            <div className="col" style={styleModalComponent.colsContainer}>
              <Card.Text>Nombre del producto</Card.Text>
            </div>
            <div className="col" style={styleModalComponent.colsContainer}>
              <Card.Text>Contenido</Card.Text>
            </div>
          </div>
        </div>
        {currentProducts.map((product, index) => {
          return (
            <div
              key={product.id + index}
              style={styleModalComponent.textContainer}
            >
              <div className="row">
                <div className="col" style={styleModalComponent.colsContainer}>
                  <Card.Title>{product.quantity}</Card.Title>
                </div>
                <div className="col" style={styleModalComponent.colsContainer}>
                  <Card.Text>{product.product_id.product_name}</Card.Text>
                </div>
                <div className="col" style={styleModalComponent.colsContainer}>
                  <Card.Subtitle className="mb-2 text-muted">
                    {product.product_id.netcontent}
                  </Card.Subtitle>
                </div>
              </div>
              {!!product.comments && (
                <>
                  <Separator altStyle={true} />
                  <div className="row">
                    <div
                      className="col"
                      style={styleModalComponent.colsContainer}
                    >
                      <Card.Text>
                        Comentarios{"\n"}
                        {product.comments}
                      </Card.Text>
                    </div>
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  const HistoryOrder = () => {
    let orderHistory = JSON.parse(orderInfo?.history);
    return (
      sizeModal === "lg" &&
      orderInfo?.history && <TimelineHistory history={orderHistory} />
    );
  };

  const addressOrder = () => {
    if (
      orderInfo.shop_comments === "WISHES" ||
      orderInfo.shop_comments === "SOLUTIONS"
    ) {
      let correctAddress = JSON.parse(JSON.parse(orderInfo.address));
      return (
        <div>
          <p>{"Desde: " + correctAddress[0].name}</p>
          <p>{"Hasta: " + correctAddress[1].name}</p>
        </div>
      );
    } else {
      return orderInfo.address;
    }
  };

  const controlSizeModal = () => {
    if (sizeModal === "lg") {
      setSizeModal("xl");
      setClassNameModal("row row-cols-2");
    } else {
      setSizeModal("lg");
      setClassNameModal("");
    }
  };

  const HeaderProds = () => {
    if (orderInfo?.shop_comments === "WISHES") {
      return (
        <div className="row row-cols-2">
          <Card.Subtitle className="mb-2 text-muted">Productos</Card.Subtitle>
          {imageTicket && (
            <Card.Subtitle className="mb-2 text-muted">
              <Button
                className={"align-self-end"}
                onClick={() => controlSizeModal()}
                variant="primary"
              >
                {sizeModal === "lg" ? "Ver ticket" : "Ocultar ticket"}
              </Button>
            </Card.Subtitle>
          )}
        </div>
      );
    } else {
      return (
        <Card.Subtitle className="mb-2 text-muted">Productos</Card.Subtitle>
      );
    }
  };

  const DeliveryData = () => {
    if (orderInfo?.delivery_man_id?.name) {
      return (
        <div>
          <Separator altStyle={true} />
          <Card.Subtitle className="mb-2 text-muted">
            Datos del repartidor
          </Card.Subtitle>
          <div>
            <Card.Text>
              {orderInfo?.delivery_man_id?.name +
                " " +
                orderInfo?.delivery_man_id?.last_name}
            </Card.Text>
          </div>
        </div>
      );
    }
  };

  const ShopData = () => {
    if (
      orderInfo.shop_comments === "WISHES" ||
      orderInfo.shop_comments === "SOLUTIONS"
    ) {
      <div />;
    } else {
      return (
        <div>
          <Separator altStyle={true} />
          <Card.Subtitle className="mb-2 text-muted">
            Datos de la tienda
          </Card.Subtitle>
          <div className="row">
            <Card.Text className="col">{orderInfo.shop_id.shop_name}</Card.Text>
            <Card.Text className="col row">
              <BsTelephoneFill
                className="col-2"
                size={25}
                color={colors.GRAY_3_COLOR}
              />
              {orderInfo.shop_id.phone_number}
            </Card.Text>
          </div>
        </div>
      );
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size={sizeModal}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Detalles de la orden</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={classNameModal}>
          <Card className="col" style={{ margin: 15 }}>
            <Card.Body>
              <Card.Title>Orden #{orderInfo.id.substring(0, 6)}</Card.Title>
              <HistoryOrder />
              <Separator altStyle={true} />
              <Card.Subtitle className="mb-2 text-muted">
                Datos del cliente
              </Card.Subtitle>
              <div>
                <Card.Text>
                  {orderInfo.customer_id.name +
                    " " +
                    orderInfo.customer_id.last_name}
                </Card.Text>
                <Card.Text>{addressOrder()}</Card.Text>
              </div>
              <DeliveryData />
              <ShopData />
              <Separator altStyle={true} />
              <HeaderProds />
              {!!currentProducts && <SectionProducts />}
            </Card.Body>
          </Card>
          {sizeModal === "xl" && orderInfo?.shop_comments === "WISHES" && (
            <Card className="col-5" style={{ margin: 15 }}>
              <Card.Body>
                <Card.Title>Ticket</Card.Title>
                {imageTicket && (
                  <div
                    style={{
                      overflow: "hidden",
                      position: "relative",
                      height: "100%",
                      width: "100%",
                    }}
                  >
                    <ReactPanZoom image={imageTicket} alt="Ticket image" />
                  </div>
                )}
              </Card.Body>
            </Card>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalOrderDetails;
